<template>
	<div class="newsletter-send-test">
		<ModalHeader
			:title="getString('send_test_email')"
			:button-text="getString('send')"
			:button-loading="loadingSendEmail"
			@click-button="sendTestEmail"
		/>
		<AppList :items="sendItems" />
	</div>
</template>

<script>
import { useLanguageStore, useNotificationStore } from '@/shared/stores';
import {useUserStore} from "@/console-new/stores/user.store";
import ModalHeader from '@/console-new/components/shared/ModalHeader.vue';
import AppList from '@/shared/components/AppList.vue';
import { validateEmail } from '@/shared/helpers/strings';
import API from '@/shared/helpers/API.js';
import {useNewsletterStore} from "@/console-new/stores";

export default {
	setup() {
		const languageStore = useLanguageStore();
		const notificationStore = useNotificationStore();
		const newsletterStore = useNewsletterStore();
		const userStore = useUserStore();
		return {
			getString: languageStore.getString,
			showNotification: notificationStore.showNotification,
			userStore, newsletterStore
		};
	},
	name: "NewsletterSendTest",
	components: {
		ModalHeader,
		AppList
	},
	data() {
		return {
			loadingSendEmail: false,
			testEmail: ''
		}
	},
	computed: {
		sendItems() {
			return [
				{
					title: this.getString('email'),
					textInput: true,
					inputType: 'email',
					placeholder: this.getString('email'),
					value: this.testEmail,
					callbackText: (newValue) => {
						this.testEmail = newValue;
					}
				}
			];
		}
	},
	methods: {
		sendTestEmail() {
			// Validate email
			if (!this.testEmail || !validateEmail(this.testEmail)) {
				this.showNotification('wrong-email');
				return;
			}

			this.loadingSendEmail = true;

			API.init().sendTestNewsletter(this.userStore.currBusinessId, this.newsletterStore.editingNewsletterId, this.testEmail, (r) => {
				this.loadingSendEmail = false;
				if (r && r.result && r.result === "OK") {
					this.showNotification('test-email-sent');
					this.testEmail = '';
					this.$emit('close');
				} else {
					this.showNotification('generic-fail');
				}
			});
		}
	}
}
</script>

<style scoped lang="scss">
.newsletter-send-test {
	// Styles if needed
}
</style>
